

































































































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays'
import format from 'date-fns/format';

import SidebarInst from '../services/sidebar';
import {clearToken} from '../services/user';
import {NoteService} from '../services/notes';

import {IHeaderOptions} from '../interfaces';

import SimpleTask from './SimpleTask.vue';

@Component({
  components: {
    SimpleTask,
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  }
})
export default class Header extends Vue {
  public sidebar = SidebarInst;
  public options!: IHeaderOptions;
  public isSaving: boolean = false;

  public toggleSidebar(show = false) {
    this.sidebar.hide = show;
  }

  public newNote() {
    this.$router.push({name: 'new-note'}).catch(err => {});
  }

  public goToSearch(searchType: string, tag: string) {
    this.$router.push({name: 'search'}).catch(err => {});
  }

  public prevent($event: any) {
    $event.stopPropagation();
  }

  public prevDay() {
    const date = subDays(this.sidebar.date, 1);
    this.$router.push({ name: 'day-id', params: { id: format(date, 'MM-dd-yyyy') } });
  }

  public nextDay() {
    const date = addDays(this.sidebar.date, 1);
    this.$router.push({ name: 'day-id', params: { id: format(date, 'MM-dd-yyyy') } });
  }

  public async save() {
    if (
      this.options.saveDisabled ||
      this.isSaving ||
      !this.options.saveFn ||
      !_.isFunction(this.options.saveFn)
    ) {
      return;
    }

    this.isSaving = true;

    try {
      await this.options.saveFn();
    } catch(e) {}

    this.isSaving = false;
  }

  public async deleteNote() {
    if (
      !this.options.showDelete ||
      this.isSaving ||
      !this.options.deleteFn ||
      !_.isFunction(this.options.deleteFn)
    ) {
      return;
    }

    this.isSaving = true;

    try {
      await this.options.deleteFn();
    } catch(e) {}

    this.isSaving = false;
  }

  public async exportNotes() {
    NoteService.exportNotes();
  }

  public logout() {
    clearToken();
    this.$router.push({name: 'Login'});
  }
}
